import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PageLoaderService } from '../core/page-loader.service';

@Component({
  selector: 'app-election-generic-error',
  imports: [CommonModule],
  templateUrl: './election-generic-error.component.html',
  styleUrl: './election-generic-error.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElectionGenericErrorComponent implements OnInit {
  constructor(private readonly pageLoaderService: PageLoaderService) {}

  ngOnInit(): void {
    this.pageLoaderService.hide();
  }
}
